import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { waLink } from "../data/site";

export const CtaBanner = () => (
  <section data-testid="cta-section" data-hide-wa className="px-5 sm:px-10 pb-20 lg:pb-28">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative overflow-hidden bg-alga text-ink shadow-[0_0_60px_-10px_rgba(255,90,0,0.6)] px-6 py-14 sm:px-12 sm:py-20 lg:px-16 lg:py-24"
    >
      <svg viewBox="0 0 64 64" aria-hidden="true" className="absolute -right-10 -bottom-10 h-56 w-56 sm:h-80 sm:w-80 text-ink/10 logo-spin">
        <polygon points="32,5 55,18.5 55,45.5 32,59 9,45.5 9,18.5" fill="none" stroke="currentColor" strokeWidth="3" />
      </svg>
      <div className="relative grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <h2 data-testid="cta-title" className="font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.92]">Sua marca merece<br />uma boa <span className="text-paper">impressão.</span></h2>
          <p className="mt-5 text-base sm:text-lg font-semibold">Impressão profissional para empresas.</p>
        </div>
        <div className="lg:col-span-4 lg:justify-self-end">
          <a href={waLink("Olá, Alfa Gráfica Digital! Gostaria de solicitar um orçamento.")} target="_blank" rel="noopener noreferrer" data-testid="cta-orcamento-btn" className="group inline-flex w-full sm:w-auto items-center justify-between gap-4 rounded-full bg-ink text-paper pl-6 pr-2 py-2 text-sm font-bold uppercase tracking-wide transition-[transform] duration-300 hover:-translate-y-0.5 active:scale-95">
            Solicitar orçamento
            <span className="grid place-items-center h-10 w-10 rounded-full bg-paper text-ink transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="h-4 w-4" /></span>
          </a>
        </div>
      </div>
    </motion.div>
  </section>
);
